(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dealer-application-form"] && !Shopify.designMode) return;
  try {
    const DEALER_FORM = '[data-dealer-application-form]';

  // The button must read «sending» from the CLICK, not from the moment this script finally sees
  // the submit event. Shopify's own spam protection for the contact form holds that event — 20 s
  // measured on the live page 2026-10-20 — and a button that still looks idle across that gap is
  // clicked again, which is exactly how a duplicate application is made.
  //
  // Busy is marked with a flag plus aria-disabled, never with `disabled`: a disabled submit button
  // cannot submit, so disabling it at click time would cancel the very submission it reports on.
  // The flag is what stops the second click.
  const markSending = (wrapper, button) => {
    wrapper.setAttribute('data-sending', '');
    if (!button) return;
    if (button.dataset.idleLabel === undefined) button.dataset.idleLabel = button.textContent;
    button.textContent = wrapper.dataset.sendingMessage || button.dataset.idleLabel;
    button.setAttribute('aria-disabled', 'true');
  };

  const markIdle = (wrapper, button) => {
    wrapper.removeAttribute('data-sending');
    if (!button) return;
    if (button.dataset.idleLabel !== undefined) button.textContent = button.dataset.idleLabel;
    button.removeAttribute('aria-disabled');
    button.disabled = false;
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('button[type="submit"]');
      if (!button) return;
      const wrapper = button.closest(DEALER_FORM);
      if (!wrapper) return;
      if (wrapper.hasAttribute('data-sending')) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      const form = button.closest('form');
      // An invalid form never reaches submit, so it must not be left reading «sending» forever.
      if (!form || !form.checkValidity()) return;
      markSending(wrapper, button);
    },
    true
  );

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const wrapper = form.closest(DEALER_FORM);
    if (!wrapper) return;
    const action = (wrapper.dataset.action || '').trim();
    if (!action) return;
    event.preventDefault();

    const payload = {};
    form.querySelectorAll('[data-field]').forEach((el) => {
      payload[el.dataset.field] = el.value;
    });
    payload.source_page = window.location.pathname;
    const button = form.querySelector('button[type="submit"]');
    // Submitting with Enter never passes through the click handler above.
    markSending(wrapper, button);

    let delivered = false;
    try {
      const response = await fetch(action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      delivered = response.ok;
    } catch (error) {
      delivered = false;
    }

    if (delivered) {
      const live = form.querySelector('.dealer-application-form__live');
      if (live) {
        live.textContent = wrapper.dataset.successMessage || '';
        live.hidden = false;
        live.focus?.();
      }
      form.reset();
      markIdle(wrapper, button);
      return;
    }

    markIdle(wrapper, button);
    form.submit();
  });
  } catch(e) { console.error(e); }
})();

})();
